import { render, staticRenderFns } from "./PhotoTagging.vue?vue&type=template&id=0c396fce&scoped=true"
import script from "./PhotoTagging.vue?vue&type=script&lang=js"
export * from "./PhotoTagging.vue?vue&type=script&lang=js"
import style0 from "./PhotoTagging.vue?vue&type=style&index=0&id=0c396fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c396fce",
  null
  
)

export default component.exports